import React from 'react'

import Horizontal from '../layouts/Horizontal.jsx'
import BarChartHOC from '../charts/BarChartHOC.jsx'
import Card from '../components/Card.jsx'
import ZeroState from '../components/ZeroState.jsx'

const PassionPoints = (props) => {
  const { title, description, section_1, selected_entities } = props.data

  return (
    <Horizontal
      title={title}
      description={description}
      page={props.index + 1}
      notes={section_1.footnote}
      content={() => (
        <Card title={section_1.title} description={section_1.subtitle} showBorder={false}>
          <ZeroState condition={!!selected_entities?.length} placeholder="No categories selected.">
            <BarChartHOC data={selected_entities} valueType="overIndex" />
          </ZeroState>
        </Card>
      )}
    />
  )
}

export default PassionPoints
